import { Typography } from "@mui/material";
import { useListContext } from "react-admin";
import NoResults from "../unit/NoResults";

const PartnersCustomLoading = ({ ...props }) => {
  const checkedField = props.checkedField;
  const { total, data, isPending, isLoading, isFetching, filterValues } =
    useListContext();
  const checkedFieldValue = filterValues?.[checkedField];
  if (checkedField && !checkedFieldValue) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        Please select referral source
      </Typography>
    );
  }
  if (isPending)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        {" "}
        pending...
      </Typography>
    );
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }
};

export default PartnersCustomLoading;
